import forumNav from '@/forumcomponents/forumNav'

export const home = [
    {
      path: '/forum',
      name: '_forumHome',
      redirect: '/forum/index',
      component: forumNav,
      children: [{
            path: '/forum/index',
            name: 'forumHome',
            component: () => 
            import ('@/forumViews/index/index')
        }]
    }
  ]